import {
  Nightlight,
  LightMode,
  CalendarMonth,
  CalendarMonthOutlined,
  ArrowDropDown,
  KeyboardArrowDown,
} from "@mui/icons-material";
import {
  MenuItem,
  Box,
  Typography,
  FormControl,
  Select,
  Tabs,
  Tab,
  Button,
  Drawer,
} from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CalendarDrawer } from "features/searchStore/components/CalendarDrawer";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";

function MCalendarSection() {
  const todayDate = new Date();
  const [openCalendar, setOpenCalendar] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleCalendarDrawerClose = () => {
    setOpenCalendar(false);
  };

  const generateNumberOpts = () => {
    const options = [];

    for (let i = 1; i <= 6; i++) {
      const option = `${i}名`;
      options.push(
        <MenuItem key={option} value={i}>
          {option}
        </MenuItem>
      );
    }
    return options;
  };
  return (
    <>
      <Box
        display="flex"
        borderTop={1}
        borderBottom={1}
        borderColor="divider"
        p={1}
        flex={1}
        sx={{ overflow: "hidden", textOverflow: "ellipsis" }}
        onClick={() => setOpenCalendar(true)}
        bgcolor="white"
        marginTop={1}
      >
        <CalendarMonthOutlined color="primary" fontSize="small" sx={{ mx: 1 }} />
        <Typography
          noWrap
          sx={{
            paddingRight: 1,
            flex: 1,
            whiteSpace: "nowrap",
          }}
        >
          {dayjs(todayDate).format("M月D日（ddd）")} (+) 19:00 2 名
        </Typography>
        <ArrowDropDown />
      </Box>

      <Drawer
        key="calendar-drawer"
        anchor="bottom"
        open={openCalendar}
        onClose={handleCalendarDrawerClose}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        }}
        PaperProps={{
          sx: {
           borderRadius: '12px 12px 0px 0px'
          },
        }}
      >
        <>
          <Box
            display="flex"
            justifyContent="center"
            width="100%"
            onClick={handleCalendarDrawerClose}
          >
            <KeyboardArrowDown fontSize="large" />
          </Box>
          <CalendarDrawer handleClose={handleCalendarDrawerClose} />
        </>
      </Drawer>
    </>
  );
}

export default MCalendarSection;
